import type { AgentCoreThreadSummary } from '@/shared/api/agentCore/agentCoreApi';

export const isThreadArchived = (thread: AgentCoreThreadSummary): boolean =>
  thread.status === 'archived';

export const splitThreadsByArchive = (
  list: AgentCoreThreadSummary[],
): { active: AgentCoreThreadSummary[]; archived: AgentCoreThreadSummary[] } => {
  const active: AgentCoreThreadSummary[] = [];
  const archived: AgentCoreThreadSummary[] = [];
  for (const thread of list) {
    (isThreadArchived(thread) ? archived : active).push(thread);
  }
  return { active, archived };
};
